export default class Kostenart {
    constructor(
        id,
        name,
        icon,
        belege = {
            active: false,
            required: false,
            max: 0,
        },
        datum = {
            active: false,
            zeitraum: false,
            required: false,
        },
        ausgabenbegrenzung = {
            active: false,
            min: 0,
            max: 0,
        },
        lerneinheiten = {
            active: false,
            required: false,
            max: 0,
        },
        hinweis = {
            active: false,
            text: '',
        }
    )
    {
        this.id = id
        this.name = name
        this.icon = icon
        this.belege = belege ? belege : {
            active: false,
            required: false,
            max: 0,
        }
        this.datum = datum ? datum : {
            active: false,
            zeitraum: false,
            required: false,
        }
        this.ausgabenbegrenzung = ausgabenbegrenzung ? ausgabenbegrenzung : {
            active: false,
            min: 0,
            max: 0,
        }
        this.lerneinheiten = lerneinheiten instanceof Object ? lerneinheiten : {
            active: false,
            required: false,
            max: 0,
        }
        this.hinweis = hinweis ? hinweis : {
            active: false,
            text: '',
        }
    }

    getFirestore(){
        return {
            id: this.id,
            name: this.name,
            icon: this.icon,
            belege: this.belege,
            datum: this.datum,
            ausgabenbegrenzung: this.ausgabenbegrenzung,
            lerneinheiten: this.lerneinheiten,
            hinweis: this.hinweis
        }
    }
}